import { getCurrentRegion } from "../helpers/siteHelpers";
import { getE2ERegion } from "./e2e";

// Automatically detect environment based on hostname
const isLocalDevelopment = () => {
  const { hostname } = window.location;
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.includes("localhost")
  );
};

const API_SERVER_PROD = "https://app.premiercardgrading.com";
const API_SERVER_DEV = "http://localhost:8080";
// const API_SERVER_DEV = "https://app.premiercardgrading.com";

// Use environment variable if set, otherwise auto-detect based on hostname
const API_SERVER =
  process.env.REACT_APP_API_SERVER ||
  (isLocalDevelopment() ? API_SERVER_DEV : API_SERVER_PROD);

// Log the API server being used (helpful for debugging)
if (isLocalDevelopment()) {
  console.log(`Using API server: ${API_SERVER}`);
}

// Region used when the hostname doesn't resolve to a known region (local dev,
// unknown hosts). Both getBaseUrl() and RegionProvider fall back to this so the
// whole app targets one region in dev instead of diverging.
export const FALLBACK_REGION = getE2ERegion() || "nz";

const API_SERVER_DEV_ENDPOINT = `${API_SERVER}/api/${FALLBACK_REGION}/v1`;

const getBaseUrl = () => {
  const region = getCurrentRegion();

  if (region && region !== "dev") {
    return `${API_SERVER}/api/${region}/v1`;
  }

  // Fallback for card-grading-new-design.web.app or other dev environments
  const { hostname } = window.location;
  if (hostname === "card-grading-new-design.web.app") {
    return `${API_SERVER}/api/nz/v1`;
  }

  return API_SERVER_DEV_ENDPOINT;
};

// export const API_BASE_URL = FORCE_API_BASE_URL || getBaseUrl();
export const API_BASE_URL = getBaseUrl();
export const API_SERVER_URL = API_SERVER;

export const PUBLIC_API_BASE_URL = `${API_SERVER}/public/api/v1`;
export const ADMIN_API_BASE_URL = `${API_SERVER}/admin/v1`;
